"use strict";
var objectFitImages = require("object-fit-images");
var aysnpm;
(function (aysnpm) {
    function findBootstrapEnvironment() {
        var envs = ['xs', 'sm', 'md', 'lg'];
        var $el = $('<div>');
        $el.appendTo($('body'));
        for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];
            $el.addClass('hidden-' + env);
            if ($el.is(':hidden')) {
                $el.remove();
                return env;
            }
        }
    }
    aysnpm.findBootstrapEnvironment = findBootstrapEnvironment;
    function findBootstrap4Environment() {
        var envs = ["xs", "sm", "md", "lg", "xl"];
        var env = "";
        var $el = $("<div>");
        $el.appendTo($("body"));
        for (var i = envs.length - 1; i >= 0; i--) {
            env = envs[i];
            $el.addClass("d-" + env + "-none");
            ;
            if ($el.is(":hidden")) {
                break; // env detected
            }
        }
        $el.remove();
        return env;
    }
    aysnpm.findBootstrap4Environment = findBootstrap4Environment;
    function getBaseUrl() {
        if (!$("#baseRef").length)
            console.error("No baseRef field defined");
        return $("#baseRef").val().toString();
    }
    aysnpm.getBaseUrl = getBaseUrl;
    function getLangShortcode() {
        if (!$("#langShortcode").length)
            console.error("No langShortcode field defined");
        return $("#langShortcode").val().toString();
    }
    aysnpm.getLangShortcode = getLangShortcode;
    function getLocalizedUrl() {
        return getBaseUrl() + getLangShortcode() + '/';
    }
    aysnpm.getLocalizedUrl = getLocalizedUrl;
    function bodyAnimateTo(scrollTop, duration, callback) {
        $('html, body').animate({
            scrollTop: scrollTop
        }, {
            duration: duration,
            complete: function () {
                if (callback)
                    callback();
            }
        });
    }
    aysnpm.bodyAnimateTo = bodyAnimateTo;
    function focusFirstError(offset, onlyFocus, callback) {
        var $arrInputError = $('input.error');
        var $arrTextareaError = $('textarea.error');
        if (!offset)
            offset = 0;
        if ($arrInputError.length || $arrTextareaError.length) {
            var numFirstErrorOffsetTop = void 0;
            var $objFirstInvalidField = void 0;
            if ($arrInputError.length) {
                $objFirstInvalidField = $arrInputError.first();
            }
            else if ($arrTextareaError.length) {
                $objFirstInvalidField = $arrTextareaError.first();
            }
            numFirstErrorOffsetTop = $objFirstInvalidField.offset().top - offset;
            if (!onlyFocus) {
                if (callback)
                    bodyAnimateTo(numFirstErrorOffsetTop, 800, function () {
                        callback();
                    });
                else
                    bodyAnimateTo(numFirstErrorOffsetTop, 800);
            }
            $objFirstInvalidField.focus();
        }
        if (callback && onlyFocus)
            callback();
    }
    aysnpm.focusFirstError = focusFirstError;
    function scrollToTop(clickSelectorEl, callback) {
        clickSelectorEl.click(function () {
            if (callback)
                bodyAnimateTo(0, 800, function () {
                    callback();
                });
            else
                bodyAnimateTo(0, 800);
        });
    }
    aysnpm.scrollToTop = scrollToTop;
    function loadScriptAsync(url) {
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.onload = function () {
                resolve("success");
            };
            script.src = url;
            document.getElementsByTagName('body')[0].appendChild(script);
        });
    }
    aysnpm.loadScriptAsync = loadScriptAsync;
    function closeCookie(cookieName, expires, noticeSelector, closeSelector) {
        if (noticeSelector.length) {
            if (Cookies.get(cookieName) == 'closed') {
                noticeSelector.hide();
            }
            else {
                noticeSelector.fadeIn();
            }
            closeSelector.bind('click', function (e) {
                e.preventDefault();
                noticeSelector.fadeOut();
                Cookies.set(cookieName, 'closed', { expires: expires, path: '/' });
            });
        }
        else
            console.error("No notice element found");
    }
    aysnpm.closeCookie = closeCookie;
    function ieObjectFitImagesFix(selectedImages) {
        /* IE OBJECT-FIT FIX
        01/ Dependancies NPM
        "object-fit-images": "3.2.3"
        02/ Dependancies SCSS
        img.object-fit-cover {
            object-fit: cover;
            &.js-ieFix {
                font-family: 'object-fit: cover;';
                //border: 1px solid coral;
            }
        }
        img.object-fit-contain {
            object-fit: contain;
            &.js-ieFix {
                font-family: 'object-fit: contain;';
                //border: 1px solid green;
            }
        }
        03/ Usage
            ieObjectFitImagesFix($('img[class^="object-fit-"]'));
        */
        var ua = window.navigator.userAgent;
        var ie = ua.indexOf("MSIE ");
        //-- check if IE to apply cover fix
        if (ie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            selectedImages.each(function () {
                //$(this).css({"font-family": "object-fit: cover;"});
                $(this).addClass("js-ieFix");
            });
            objectFitImages(selectedImages, { watchMQ: true });
        }
    }
    aysnpm.ieObjectFitImagesFix = ieObjectFitImagesFix;
})(aysnpm || (aysnpm = {}));
module.exports = aysnpm;
//# sourceMappingURL=npm-library.js.map